import { useSearchParams } from 'react-router-dom';

export const useIsSearchParamEqualTo = () => {
  const [searchParams] = useSearchParams();

  return <T>(key: keyof T, value: string): boolean => searchParams.get(key as string) === value;
};
